import { render, staticRenderFns } from "./EmergenzaEditComponent.vue?vue&type=template&id=1eebd0df&scoped=true"
import script from "./EmergenzaEditComponent.vue?vue&type=script&lang=js"
export * from "./EmergenzaEditComponent.vue?vue&type=script&lang=js"
import style0 from "./EmergenzaEditComponent.vue?vue&type=style&index=0&id=1eebd0df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eebd0df",
  null
  
)

export default component.exports